import MrpaSelect from '@/components/services/common/MrpaSelect.vue';
import MrpaSubject from '@/components/services/common/MrpaSubject.vue';
import ProxyInfo from './ProxyInfo.vue';
import AccountBankDetails from './AccountBankDetails.vue';
import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const steps: unknown[] = [MrpaSubject, ProxyInfo, AccountBankDetails];

if (isMrpaEnable(StatementType.EXTRACTION_ROD)) {
  steps.unshift(MrpaSelect);
}

export default steps;
